export enum PuppetType {
    Background = 0,
    Character = 1,
    Prop = 2,
}
